import { useMediaQuery } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { TableDisplay } from '../../../presentation-components/miscellaneous-components/table-display';
import { IHeadCell } from '../../../../shared/interfaces/table-display.model';
import gaiaTheme from '../../../../root-components/theme';
import { useNavigate } from 'react-router-dom';
import ReportPeriodService from '../../../../shared/services/report-period/report-period.service';
import { IReportPeriod } from '../../../../shared/services/report-period/report-period.model';
import { UserDetailsContext } from '../../../../context/user-details/user-details';
import { UserNotificationsContext } from '../../../../context/user-notifications/user-notifications';
import { LoadingPage } from '../../loading-page';
import { PageOuterContainer } from '../../../../root-components/layouts/page-outer-container';
import { PageHeading } from '../../../presentation-components/display-elements-components/page-heading';


export const ReportingSecrPage = () => {
  const navigate = useNavigate();
  //Servuces
  const userDetailsContext = useContext(UserDetailsContext)
  const userDetails = userDetailsContext.userDetails
  const userNotificationsContext = useContext(UserNotificationsContext)
  const reportPeriodService = new ReportPeriodService();
  //State
  const [allReportPeriods, setAllReportPeriods] = useState<IReportPeriod[]>([]);
  //Table State
  const [selected, setSelected] = useState<string[]>([]);
  const [inputPage, setInputPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0)
  const [perPage, setPerPage] = useState(10)
  //Loading State
  const [isLoading, setIsLoading] = useState<boolean>(true)
  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  //Variables
  const companyName = (!userDetails?.isPartner && userDetails?.partnerOrganisation) || (userDetails?.isPartner && userDetails?.isLoggedInAsClient) ? userDetails?.partnerOrganisation?.partnerName : 'Gaia';

  useEffect(() => {
    reportPeriodService.getAllReportPeriodsWithReportDetailsPagination(`includeSecr=true`, inputPage, perPage)
      .then(response => {
        setIsLoading(false)
        setAllReportPeriods(response.rows)
        setTotalRecords(response.count);
      })
      .catch(err => console.log(err))
  }, [inputPage, perPage])

  const transformArray = (arr: string[]) => {
    return arr.map(str =>
      str.split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    );
  };

  const headCells: IHeadCell[] = [
    { id: 'reportPeriod', numeric: false, label: 'Report Period', sortable: false, isHeading: true },
    { id: 'includeBoolean', numeric: false, label: 'Includes', sortable: false },
    { id: 'intensityRatios', numeric: false, label: 'Intensity Ratio(s)', sortable: false },
    { id: 'markedAsCompleted', numeric: false, label: 'Status', sortable: false, isSubHeading: true },
  ];


  const rows = allReportPeriods.map(reportPeriod => {
    return {
      id: reportPeriod.generatedReports && reportPeriod.generatedReports[0] ? reportPeriod.generatedReports[0].id : reportPeriod.id,
      reportPeriod: reportPeriod.friendlyName,
      includeBoolean: reportPeriod.generatedReports && reportPeriod.generatedReports[0] ? [
        // reportPeriod.generatedReports[0].includeBaseYear ? 'Base Year' : '',
        reportPeriod.generatedReports[0].includeGlobal ? 'Global' : '',
        reportPeriod.generatedReports[0].includeScopeThree ? 'Scope Three' : ''
      ].filter(Boolean).join(', ') : [],
      intensityRatios: reportPeriod.generatedReports && reportPeriod.generatedReports[0] ? transformArray(reportPeriod.generatedReports[0].intensityRatios).join(', ') : [],
      markedAsCompleted: reportPeriod.generatedReports && reportPeriod.generatedReports[0] ? reportPeriod.generatedReports[0].markedAsCompleted === true ? 'Completed' : 'In Progress' : 'Not Started',
    }
  });

  const handleSelected = (selectedRowId: string[]) => {
    if (!userDetails?.organisation.subscriptionActive || (userDetails.organisation.subscriptionActive && userDetails.organisation.freeTrialDaysRemaining && userDetails.organisation.freeTrialDaysRemaining > 0)) {
      userNotificationsContext.openDialog({ active: true, hideCancelButton: true, title: 'Access Denied', message: `You must have a subscription to ${companyName} Carbon Accounting to be able to generate your SECR Report.`, buttonCopy: 'Ok', })
    }
    else {
      if (selectedRowId[0] !== undefined) {
        //see whether the selectedRowId[0] is in reportPeriod.id
        const reportPeriodId = allReportPeriods.find(reportPeriod => reportPeriod.id === selectedRowId[0])
        if (reportPeriodId) {
          navigate(`/reporting/secr/form?reportPeriodId=${selectedRowId[0]}`)
        } else {
          navigate(`/reporting/secr/${selectedRowId[0]}`)
        }
      }
    }
  }

  return (
    <PageOuterContainer>
      <PageHeading
        title='Streamlined Energy and Carbon Reports (SECR)'
        includeBackButton={true}
        backButtonLink='/reporting'
        backButtonText='Back to reporting'
      />
      <LoadingPage pageReady={!isLoading}>
        {allReportPeriods &&
          <TableDisplay
            isMobileMode={isMobileMode}
            headCells={headCells}
            rows={rows}
            handleSelected={handleSelected}
            selected={selected}
            setSelected={setSelected}
            inputPage={inputPage}
            setInputPage={setInputPage}
            totalRecords={totalRecords}
            perPage={perPage}
            setPerPage={setPerPage}
          />
        }
      </LoadingPage>
    </PageOuterContainer>
  )
}